module.exports = __webpack_public_path__ + "static/media/drag-background.faaee4c4.svg";